// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KIC3XZU6Fy {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.KIC3XZU6Fy h4 {
  line-height: 3em;
}
.KIC3XZU6Fy .Daxe1CU6Es {
  float: left;
  width: 100%;
}
.KIC3XZU6Fy .LMZ3OQ_yIN {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.KIC3XZU6Fy .LMZ3OQ_yIN:hover {
  cursor: pointer;
}
.KIC3XZU6Fy .LMZ3OQ_yIN:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.g1Vtfz3Mme .rLgvHCvy02:focus {
  outline: none;
}
.g1Vtfz3Mme .rLgvHCvy02.WUfs4vPG02.lVhSOXwrhA {
  background: #375A88;
}
.g1Vtfz3Mme .rLgvHCvy02.WUfs4vPG02.lVhSOXwrhA span {
  color: #fff;
}
.g1Vtfz3Mme .lVhSOXwrhA {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.g1Vtfz3Mme .lVhSOXwrhA:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.g1Vtfz3Mme input {
  height: 38px;
  min-width: 220px;
}
.LMZ3OQ_yIN.nq82ThBSJv {
  background: #410102;
}
.LMZ3OQ_yIN.tKMXyauDar {
  background: #911318;
}
.LMZ3OQ_yIN.CvUoDMbYbJ {
  background: #D8293B;
}
.LMZ3OQ_yIN.IIruxjkaSo {
  background: #F2373C;
}
.LMZ3OQ_yIN.MRZjw7f6db {
  background: #FC4448;
}
.LMZ3OQ_yIN.iBQmftRKLf {
  background: #ED535E;
}
.LMZ3OQ_yIN.NkrZJbwXz3 {
  background: #E34926;
}
.LMZ3OQ_yIN.Z3OPcWwjGW {
  background: #FC562B;
}
.LMZ3OQ_yIN.MvuZPvQulu {
  background: #FC6722;
}
.LMZ3OQ_yIN.QrKRhcV0dx {
  background: #FD7F24;
}
.LMZ3OQ_yIN.RfA5QpPhjr {
  background: #FD8D26;
}
.LMZ3OQ_yIN.phO1nsodQt {
  background: #EC9C3E;
}
.LMZ3OQ_yIN.LgCBD6C67N {
  background: #0e673a;
}
.LMZ3OQ_yIN.I04Tcg7W6N {
  background: #208740;
}
.LMZ3OQ_yIN.A3IVyNrYqJ {
  background: #239718;
}
.LMZ3OQ_yIN.emZ4wOJorO {
  background: #55A84D;
}
.LMZ3OQ_yIN.lJazOPD81t {
  background: #4BBE5A;
}
.LMZ3OQ_yIN.NIlrcjjw9G {
  background: #0CCA6A;
}
.LMZ3OQ_yIN.sQloAyzUhS {
  background: #0A3C64;
}
.LMZ3OQ_yIN.ug2j0blKG3 {
  background: #0d487a;
}
.LMZ3OQ_yIN.YR7bNzPOWA {
  background: #10538d;
}
.LMZ3OQ_yIN.ACkUs3V8sN {
  background: #115A99;
}
.LMZ3OQ_yIN.XCGBVE9oDb {
  background: #3387E2;
}
.LMZ3OQ_yIN.pAJo3dJVwE {
  background: #1BA9CF;
}
.LMZ3OQ_yIN.UhXEmJoNAF {
  background: #d27c02;
}
.LMZ3OQ_yIN.xFAXBOIaQt {
  background: #fb9402;
}
.LMZ3OQ_yIN.T3MbOwRVw6 {
  background: #FD9B30;
}
.LMZ3OQ_yIN.fiJ9jezS5k {
  background: #FDBE2D;
}
.LMZ3OQ_yIN.CeHbDguHwe {
  background: #FED831;
}
.LMZ3OQ_yIN.k0MVvnCef1 {
  background: #FFFD38;
}
.LMZ3OQ_yIN.VHchmF4qXt {
  background: #2D215C;
}
.LMZ3OQ_yIN.rbWmRfncBu {
  background: #483C83;
}
.LMZ3OQ_yIN._P0kL21iJW {
  background: #58518d;
}
.LMZ3OQ_yIN.OREIr_pmOg {
  background: #7068A9;
}
.LMZ3OQ_yIN._EkS7TZXv6 {
  background: #7f78b2;
}
.LMZ3OQ_yIN.DrtrJBY9Es {
  background: #8f88bc;
}
.LMZ3OQ_yIN.IVVrwDYZwu {
  background: #000;
}
.LMZ3OQ_yIN.mXt9l0kpPI {
  background: #282626;
}
.LMZ3OQ_yIN.nxkZpni75K {
  background: #242222;
}
.LMZ3OQ_yIN.NPS51aNpFG {
  background: #353838;
}
.LMZ3OQ_yIN.rN1Jj3Yyyx {
  background: #666;
}
.LMZ3OQ_yIN.FyuFJFEImJ {
  background: #999;
}
.DKcls_XTPb {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.DKcls_XTPb ._EzjcmUJld {
  display: none;
}
.N2cMtnWG65 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 24px 12px 24px;
  margin-right: 8px;
}
.N2cMtnWG65 .j4LkEixddZ {
  font-weight: 300;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `KIC3XZU6Fy`,
	"color-row": `Daxe1CU6Es`,
	"color-tile": `LMZ3OQ_yIN`,
	"picker-component": `g1Vtfz3Mme`,
	"picker-element": `rLgvHCvy02`,
	"active": `WUfs4vPG02`,
	"btn": `lVhSOXwrhA`,
	"red-1": `nq82ThBSJv`,
	"red-2": `tKMXyauDar`,
	"red-3": `CvUoDMbYbJ`,
	"red-4": `IIruxjkaSo`,
	"red-5": `MRZjw7f6db`,
	"red-6": `iBQmftRKLf`,
	"orange-1": `NkrZJbwXz3`,
	"orange-2": `Z3OPcWwjGW`,
	"orange-3": `MvuZPvQulu`,
	"orange-4": `QrKRhcV0dx`,
	"orange-5": `RfA5QpPhjr`,
	"orange-6": `phO1nsodQt`,
	"green-1": `LgCBD6C67N`,
	"green-2": `I04Tcg7W6N`,
	"green-3": `A3IVyNrYqJ`,
	"green-4": `emZ4wOJorO`,
	"green-5": `lJazOPD81t`,
	"green-6": `NIlrcjjw9G`,
	"blue-1": `sQloAyzUhS`,
	"blue-2": `ug2j0blKG3`,
	"blue-3": `YR7bNzPOWA`,
	"blue-4": `ACkUs3V8sN`,
	"blue-5": `XCGBVE9oDb`,
	"blue-6": `pAJo3dJVwE`,
	"yellow-1": `UhXEmJoNAF`,
	"yellow-2": `xFAXBOIaQt`,
	"yellow-3": `T3MbOwRVw6`,
	"yellow-4": `fiJ9jezS5k`,
	"yellow-5": `CeHbDguHwe`,
	"yellow-6": `k0MVvnCef1`,
	"purple-1": `VHchmF4qXt`,
	"purple-2": `rbWmRfncBu`,
	"purple-3": `_P0kL21iJW`,
	"purple-4": `OREIr_pmOg`,
	"purple-5": `_EkS7TZXv6`,
	"purple-6": `DrtrJBY9Es`,
	"black-1": `IVVrwDYZwu`,
	"black-2": `mXt9l0kpPI`,
	"black-3": `nxkZpni75K`,
	"black-4": `NPS51aNpFG`,
	"black-5": `rN1Jj3Yyyx`,
	"black-6": `FyuFJFEImJ`,
	"picker-theme": `DKcls_XTPb`,
	"arrow-regular": `_EzjcmUJld`,
	"footer-component__root": `N2cMtnWG65`,
	"add-timesheet__submit--button": `j4LkEixddZ`
};
export default ___CSS_LOADER_EXPORT___;
